export default "__VITE_ASSET__8de26adb__"